import React, { Component } from 'react';

import UserModel from './UserModel'

import { Table, Popconfirm, Typography } from 'antd';

class UserTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Celé jméno',
    dataIndex: 'name',
    key: 'name',
    width: 250,
    sorter: (a, b) => a.name - b.name,
  }, {
    title: 'Uživ. jméno',
    dataIndex: 'username',
    key: 'username',
    width: 200,
    sorter: (a, b) => a.username - b.username,
  }, {
    title: 'Role',
    dataIndex: 'roles',
    key: 'roles',
    render: (text, record) => {
      return text.join(', ');
    }
  }, {
    title: 'Akce',
    key: 'Action',
    width: 100,
    render: (text, record) => {
      if (record.username !== 'admin' && UserModel.isInRoles(['ADMIN', 'SYSTEM_USERS_WRITE'])) {
        return (
          <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
            this.props.onRemoveRow(record.id)
          }} okText="Ano" cancelText="Ne">
            <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
          </Popconfirm>
        );
      }
    },
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        style={{ border: '0px' }} />
    );
  }
}

export default UserTable;


// WEBPACK FOOTER //
// ./src/components/UserTable.js